"use strict";

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = _assign2.default || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (scaffold, selector) {
  return _extends({}, scaffold, {
    data: scaffold.data.bind(null, selector),
    error: scaffold.error.bind(null, selector),
    loaded: scaffold.loaded.bind(null, selector),
    loading: scaffold.loading.bind(null, selector),
    keys: scaffold.keys.bind(null, selector),
    select: scaffold.select.bind(null, selector),
    lastLoadedKey: scaffold.lastLoadedKey.bind(null, selector),
    lastRequestedKey: scaffold.lastRequestedKey.bind(null, selector)
  });
};